import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DSButton, { BUTTON_VARIANT } from '@elliemae/ds-button';
import DSSeparator from '@elliemae/ds-separator';
import { DropDownContext } from '../context.js';

/* eslint-disable import/no-cycle */

var MultiSelectHeader = function MultiSelectHeader(props) {
  var totalItems = props.children.length;
  var selectedItems = props.children.filter(function (child) {
    return child.props.isSelected;
  }).length;

  var _useContext = useContext(DropDownContext),
      onSelectAll = _useContext.onSelectAll,
      selectAllDisabled = _useContext.selectAllDisabled;

  var isClearButtonDisabled = selectedItems === 0;
  var isAllButtonDisabled = selectedItems === totalItems;
  return /*#__PURE__*/React.createElement(HeaderWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(HeaderTitle, null, "".concat(selectedItems, " selected")), !selectAllDisabled && /*#__PURE__*/React.createElement(ActionButtons, null, /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "text",
    labelText: "All",
    size: "s",
    onClick: function onClick() {
      return onSelectAll(true);
    },
    "aria-disabled": isAllButtonDisabled ? 'true' : 'false',
    variant: isAllButtonDisabled && BUTTON_VARIANT.DISABLED
  }), /*#__PURE__*/React.createElement(StyledSeparator, {
    orientation: "vertical",
    position: "center",
    type: "group-level",
    margin: "none"
  }), /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "text",
    labelText: "Clear",
    size: "s",
    onClick: function onClick() {
      return onSelectAll(false);
    },
    "aria-disabled": isClearButtonDisabled ? 'true' : 'false',
    variant: isClearButtonDisabled && BUTTON_VARIANT.DISABLED
  }))), /*#__PURE__*/React.createElement(DSSeparator, {
    position: "center",
    type: "non-form",
    margin: "none"
  }));
};

var HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "zjm4r5-0"
})(["display:flex;flex-direction:column;padding:0 ", ";"], function (props) {
  return props.theme.space.xs;
});
var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "zjm4r5-1"
})(["display:flex;align-items:flex-end;justify-content:space-between;height:", ";padding-bottom:4px;"], function (props) {
  return props.theme.space.s;
});
var HeaderTitle = /*#__PURE__*/styled.span.withConfig({
  componentId: "zjm4r5-2"
})(["color:", ";"], function (props) {
  return props.theme.colors.neutral[500];
});
var ActionButtons = /*#__PURE__*/styled.div.withConfig({
  componentId: "zjm4r5-3"
})(["display:inline-flex;color:", ";"], function (props) {
  return props.theme.colors.neutral[500];
});
var StyledSeparator = /*#__PURE__*/styled(DSSeparator).withConfig({
  componentId: "zjm4r5-4"
})(["height:auto;width:auto;"]);
var StyledButton = /*#__PURE__*/styled(DSButton).withConfig({
  componentId: "zjm4r5-5"
})(["padding:0 ", ";"], function (props) {
  return props.theme.space.xxs;
});
MultiSelectHeader.propTypes = {
  children: PropTypes.array
};

export default MultiSelectHeader;
//# sourceMappingURL=MultiSelectHeader.js.map
